<div
class="dialog-banner-wrapper"
[class.hidden]="showScrolledHeader"
>
  <mnt-button-icon
    icon="caret-down"
    size="medium"
    variant="regular"
    color="neutral"
    (buttonClick)="closeDialog()"
  ></mnt-button-icon>
  <span class="dialog-banner-overlay"></span>

  <div class="dialog-banner-placeholder" *ngIf="!product.img">
    <mnt-icon
      icon="image"
      color="#4B5053"
      size="80"
    ></mnt-icon>
  </div>
  <img
    *ngIf="product.img"
    [src]="product.img"
    [alt]="product.name"
    class="dialog-banner"
  />
</div>
<!-- <div class="dialog-header-fixed" [class.visible]="showScrolledHeader">
  <app-bar
    [title]="product.name"
    [backButtonProps]="backButtonProps"
    (backButtonClick)="closeDialog()"
  ></app-bar>
</div> -->
<div class="dialog-container dialog-container-scrolled-fix">
  <div class="dialog-body">
    <div class="item-header">
      <h2 class="title-large">
        {{ product.name }}
      </h2>
      <p class="body-small text-color-subtitle" *ngIf="product.description">
        {{ product.description }}
      </p>
      <div class="price-container">
        @if(product.promotional_price && product.promotional_percentage) {
          <span class="label-medium-medium">
            {{ product.promotional_price | currency }}
          </span>
          <span class="label-regular-small label-color-subtitle text-decoration-line-through">
            {{ product.price | currency }}
          </span>
          <mnt-badge
            [label]="'-' + product.promotional_percentage + '%'"
            size="tiny"
            tone="highlight"
            color="primary"
          ></mnt-badge>
        } @else {
          <span class="label-medium-medium">
            {{ product.price | currency }}
          </span>
        }
      </div>
    </div>

    <div class="textarea-group">
      <label class="label-medium-medium">
        Alguma observação?
      </label>
      <textarea
        placeholder="Ex: tirar o picles, maionese à parte, etc..."
        maxlength="300"
        [value]="additionalInfo"
        (change)="onObservationChange($event)"
      ></textarea>
    </div>
  </div>
</div>
<div class="dialog-footer" *ngIf="isOpened && moduleBot">
  <mnt-field-number
    [min]="1"
    [max]="99"
    [value]="quantity"
    [step]="1"
    variant="simple"
    size="medium"
    color="primary"
    (change)="onQuantityChange($event)"
  ></mnt-field-number>
  <mnt-button
    [label]="`Adicionar ${getTotalPrice() | currency}`"
    size="medium"
    color="primary"
    variant="emphasis"
    (buttonClick)="handleAddToCart()"
  ></mnt-button>
</div>